module.exports = __webpack_public_path__ + "static/media/tree_14.21740213.jpg";